export enum ArticlesLetterDescriptionEnum {
  MA0117 = 'MA0117',
  MA0118 = 'MA0118',
  MA0119 = 'MA0119',
}
export enum ArticlesPriceLetterEnum {
  MA0117 = 16.2,
  MA0118 = 13.4,
  MA0119 = 11.4,
}

export const getArticlesLetterItem = (type: ArticlesLetterDescriptionEnum, t: (n: string) => string) => {
  return {
    price: ArticlesPriceLetterEnum[type],
    description: t(`invoice:articlesLetterDescription.${type}`) || t('invoice:articlesLetterDescription.unknown'),
  };
};
